import { createCtxUseState } from "./stateManager";

export const [ctxTab, PageProvider] = createCtxUseState("Q");

export default PageProvider 